module.exports = __webpack_public_path__ + "img/delect.65dd79d0.svg";